"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genAccDiscriminator = genAccDiscriminator;
const manifest_1 = require("../manifest");
const bs58_1 = __importDefault(require("bs58"));
const keccak256_1 = __importDefault(require("keccak256"));
function genAccDiscriminator(accName) {
    return (0, keccak256_1.default)(Buffer.concat([
        Buffer.from(bs58_1.default.decode(manifest_1.PROGRAM_ID.toBase58())),
        Buffer.from(accName),
    ])).subarray(0, 8);
}
